import React from "react";
import { BannerHero } from "./BannerHero";
import { DeliveryOptions } from "./DeliveryOptions";

const Banner = () => (
    <div className="homepage-banner">
        <BannerHero />
        <DeliveryOptions />
    </div>
);

export default Banner;
